import { render, staticRenderFns } from "./agentRequestWithdrawList.vue?vue&type=template&id=36b990e8&scoped=true&lang=html&"
import script from "./agentRequestWithdrawList.vue?vue&type=script&lang=js&"
export * from "./agentRequestWithdrawList.vue?vue&type=script&lang=js&"
import style0 from "./agentRequestWithdrawList.vue?vue&type=style&index=0&id=36b990e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b990e8",
  null
  
)

export default component.exports